const Faq = store => ({
  bank: [
    {
      title: 'Come posso pagare la mia auto?',
      content: `
Puoi pagare il saldo residuo tramite bonifico bancario online, inviando il pagamento a:<br/><br/>
Numero di conto IBAN: IT96U0503401636000000015719<br/>
Nome del titolare del contro: brumbrum S.p.A.<br/>
Riferimento del pagamento: Ordine n. ${store.ordine.id_ordine} - Nome Cognome
`,
    },
    {
      title: 'Quando riceverò la mia auto?',
      content:
        "Riceverai la tua auto brumbrum direttamente a casa a partire da 7 giorni dalla conferma dell'ordine. Consegniamo 6 giorni a settimana, da lunedì a sabato. Ti contatteremo telefonicamente per concordare insieme la data e l'ora di consegna.",
    },
    {
      title: "Cosa devo avere con me al momento della consegna dell'auto?",
      content: `
      Dovrai avere con te:
<ul>
  <li>- Una copertura assicurativa minima (RCA) dell'auto acquistata, valida dal giorno stesso o da quello precedente al ritiro</li>
  <li>- Istanza Unificata in originale</li>
  <li>- I tuoi documenti d'identità in corso di validità</li>
</ul>
`,
    },
    {
      title: "Come riceverò tutti i documenti originali dell'auto?",
      content:
        "I documenti dell'auto verranno spediti con corriere all'indirizzo da te fornito.",
    },
  ],
  finanziamento: [
    {
      title: `Come posso pagare il saldo?`,
      content: `Potrai pagare la quota di saldo tramite bonifico bancario al seguente IBAN: IT96U0503401636000000015719 - Intestatario: brumbrum S.p.A. - Causale: Ordine n. ${store.ordine.id_ordine} - Nome Cognome`,
    },
    {
      title: `Quanto tempo richiede la consegna dell'auto?`,
      content: `La consegna dell'auto avviene a partire da 7 giorni dalla contabilizzazione del saldo del veicolo in caso di ordine con bonifico, o della quota non finanziata in caso di ordine con finanziamento. Se hai scelto un finanziamento per il 100% dell’importo, i 7 giorni decorreranno dall’approvazione del finanziamento da parte della finanziaria.`,
    },
    {
      title: `Cosa devo avere con me al momento della consegna dell'auto?`,

      content: `Per poter ritirare l’auto dovrai avere una copertura assicurativa minima (RCA) dell'auto acquistata, valida dal giorno stesso o da quello precedente al ritiro. L'Istanza Unificata in originale e i tuoi documenti d'indentità in corso di validità.`,
    },
    {
      title: `Come riceverò tutti i documenti originali dell'auto?`,
      content: `I documenti dell'auto verranno spediti con corriere all'indirizzo da te fornito.`,
    },
  ],

  noleggioArval: [
    {
      title: `Cosa include il canone mensile?`,
      content: `Il canone fisso include i seguenti contenuti: 100.000 km, soccorso stradale h24, manutenzione completa (ordinaria e straordinaria), consegna a domicilio, RCA e limitazioni di responsabilità su ulteriori danni e guida libera.`,
    },
    {
      title: `Quali sono i tempi di consegna?`,
      content: `Le auto in pronta consegna vengono consegnate in circa 30 giorni dalla data di accettazione dell'ordine da parte della società di noleggio. Per le auto non in pronta consegna i tempi variano in base ai tempi di produzione dello specifico modello. Un nostro agente può fornirle maggiori dettagli sull'auto di suo interesse.`,
    },
    {
      title: `Si può usare la carta di credito per noleggiare?`,
      content: `No, non è possibile pagare con la carta di credito. L'importo del canone sottoscritto verrà addebitato direttamente sul suo conto corrente bancario o postale.`,
    },
    {
      title: `L'anticipo verrà restituito alla fine del periodo di noleggio?`,
      content: `No, l'anticipo non è un deposito cauzionale. Si tratta di una somma da versare alla firma del contratto al fine di ridurre il canone da sostenere mensilmente.`,
    },
    {
      title: `Quando si inizia a pagare i canoni?`,
      content: `L’addebito dei canoni avverrà solo dopo la consegna dell’auto.`,
    },
    {
      title: `Quando dovrà essere versato l’anticipo?`,
      content: `L’anticipo dovrà essere versato al momento della firma del contratto di noleggio e comunque successivamente all’approvazione dei requisiti finanziari da parte della società di noleggio.`,
    },
  ],

  noleggioBrumbrum: [
    {
      title: `Si può usare la carta di credito per noleggiare?`,
      content: `No, non è possibile pagare con la carta di credito. L'importo del canone sottoscritto verrà addebitato direttamente sul suo conto corrente bancario o postale.`,
    },
    {
      title: `L'anticipo verrà restituito alla fine del periodo di noleggio?`,
      content: `No, l'anticipo non è un deposito cauzionale. Si tratta di una somma da versare alla firma del contratto al fine di ridurre il canone da sostenere mensilmente.`,
    },
    {
      title: `Quando si inizia a pagare i canoni?`,
      content: `L’addebito dei canoni avverrà solo dopo la consegna dell’auto.`,
    },
  ],
})

export default Faq
